/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ leftChain: NonNullable<unknown>, distance: NonNullable<unknown>, rightChain: NonNullable<unknown> }} Chain_Page_Compare_Launched_Right_BetterInputs */



/**
* | output |
* | --- |
* | "{leftChain} was launched {distance} after {rightChain}" |
*
* @param {Chain_Page_Compare_Launched_Right_BetterInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_launched_right_better = /** @type {((inputs: Chain_Page_Compare_Launched_Right_BetterInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Launched_Right_BetterInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`${i?.leftChain} was launched ${i?.distance} after ${i?.rightChain}`)
});